import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import SupportSvg from '../../../assets/icons/nav/support.svg?raw';

export const SupportIcon = (props) => <CustomSVG svg={SupportSvg} preserveColors {...props} />;
